import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_11867_68028)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 2.37915C6.25736 2.37915 5.25 3.38651 5.25 4.62915V21.1292C5.25 22.3718 6.25736 23.3792 7.5 23.3792H16.5C17.7426 23.3792 18.75 22.3718 18.75 21.1292V4.62915C18.75 3.38651 17.7426 2.37915 16.5 2.37915H7.5ZM17.25 3.87915H6.75V21.8792H17.25V3.87915Z",
			fill: "#000000"
		}), /* @__PURE__ */ _jsx("rect", {
			x: 9.75,
			y: 4.62915,
			width: 4.5,
			height: 1.5,
			rx: .75,
			fill: "#000000"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_11867_68028",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0 0.87915)"
		})
	}) })]
});
export default SvgPhoneIcon;
